__turbopack_context__.v({
  "simpleInput": "EloqJW_simpleInput",
});
